module.exports = __webpack_public_path__ + "img/stripe-badge-grey.79b77d9e.png";